exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-weight:700}.container-fluid,html{background:#868686}.container-fluid{padding:0}.content-wrapper{margin-top:116px;min-height:calc(100vh - 325px);background:#868686}.content{box-shadow:1px 4px 18px -8px #000;border-radius:5px;background:#fff}", ""]);

// exports
